import * as TK from 'components/site/SiteAvatarRadioGroup/translations/constants';
import { Translations } from 'translations/types';

export const siteAvatarRadioGroupEnUsLocale: Translations = {
  [TK.SITE_AVATAR_RADIO_GROUP_UPLOAD_PHOTO]: 'Upload Your Photo',
  [TK.SITE_AVATAR_RADIO_GROUP_USE_NAME_INITIALS]: 'Use Name Initials',
  [TK.SITE_AVATAR_RADIO_GROUP_DIVIDER]: 'OR',
};
